import { SET_DOB } from '../constants/actionTypes'

const setDOB = (state = {}, action) => {
    switch (action.type) {
        case SET_DOB:
            return action.payload
        default:
            return state
    }
}
export default setDOB
